// /assets/scripts/dictionary/pjax/_afterPageChange.js
import { langCheck } from '../../lib/_lang_check.js';
import { logVisualize } from '../_log_visualize.js';
import { getVisited } from '../../lib/_indexSearch.js';
import { kvMovie } from '../../lib/_kvMovie.js';
import { productsTool } from '../../lib/_products.js';
import { legal } from '../../lib/_legal.js';
import { deleteDomain } from '../../lib/_tool.js';
import { collections } from './_collections.js';
/**
 * ページ差し替え後の共通初期化。
 * 既存の this._afterPageChange と等価の処理を外部化。
 *
 * @param {Object}  opts
 * @param {Element} opts.rootEl           - Pjax のルート（= this.targetEl）
 * @param {string}  opts.blockSelector    - data-page ブロックのセレクタ（= this.blockSelector）
 * @param {Function}opts.ensureProductInfo- this._ensureProductInfo を bind して渡す
 * @param {Element} [opts.scope=null]     - 直近に影響するブロック（無ければ最前面を推定）
 * @param {string}  [opts.reason='']      - 呼び出し理由（debug/イベント連携用）
 */
export function afterPageChange(opts = {}) {
	const {
		rootEl,
		blockSelector,
		ensureProductInfo,
		scope = null,
		reason = '',
	} = opts;
	
	if (!rootEl || !blockSelector) { //間違って呼んだ時に落ちないようにチェック
		console.warn('[afterPageChange] missing rootEl or blockSelector');
		return;
	}
	
	const pages = rootEl.querySelectorAll(blockSelector);
	const top   = scope || pages[pages.length - 1] || null;

	// DOM安定後に走らせたい処理は rAF×2
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			// ---- ページ共通セットアップ ----
			collections.addHTML();
			langCheck.start(rootEl);
			//getVisited.check?.();
			logVisualize.setArray?.(rootEl);
			kvMovie.resize?.();
			kvMovie.checkPlay?.();
			getVisited.load();
			
			console.log("after page load")
			// ---- Shopify 関連（fetch無しの戻りでも最低限の念押し）----
			if (top && typeof ensureProductInfo === 'function') {
				ensureProductInfo(top);
			}

			// ---- ページ種別で分岐（必要ならここに追記していく）----
			try {
				if (top?.querySelector?.('product-info')) {
					// 商品詳細ページ向けの追加処理があればここで
					productsTool.init(top?.querySelector?.('product-info'));
				} else if (top?.querySelector?.('.collection-template')) {
					// 一覧ページ用の初期化など
				}
				//console.log(top.querySelector(".shopify-policy__container"));
				if ( top.querySelector(".shopify-policy__container") ) {
					// Legal系ページ
					legal.init( top );
				}
				if( top.querySelector(`[data-template="item"]`) ){
					let $dom = top.querySelector(`[data-template="item"] .dictionary_detail .txt`);
					deleteDomain( $dom );
				}
				if( top.querySelector(".contact_page_contact") ){
					legal.checkContactAfterSend();
				}
			} catch (e) {
				console.warn('[afterPageChange] per-page branch error', e);
			}

			// 外部通知（必要なら他モジュールがフックできます）
			document.dispatchEvent(new CustomEvent('pjax:pagechange', {
				detail: { top, reason }
			}));
		});
	});
}
export let resizeProducts = {
	title: function(){
		const productPages = document.querySelectorAll(`#page_content [data-page="product"]`);
		//console.log("Product: ", productPages);
		productPages.forEach( (el, index) => {
			productsTool.setTitleHeight(el);
		});
		
	}
}